import React from 'react';
import { Calendar, FlightOut, Nights, Plane } from '@lt/components/icons-react/userflow';
import { SearchType } from '../../../../types';
import { SEARCH_TYPE_NAMES } from '../../../../constants';

type TextVariantWithMobile = (searchType: SearchType, isMobile?: boolean) => string;
export interface FieldParams {
  name: string;
  placeholder: TextVariantWithMobile;
  icon: React.ReactNode;
}

export const fieldParams: Record<string, FieldParams[]> = {
  days: [
    {
      name: 'start',
      placeholder: (searchType, isMobile) => {
        if (searchType === SEARCH_TYPE_NAMES.HOTEL) return 'Заезд';
        return isMobile ? 'Дата вылета' : 'Туда';
      },
      icon: <Plane width={24} height={24} />,
    },
    {
      name: 'end',
      placeholder: (searchType, isMobile) => {
        if (searchType === SEARCH_TYPE_NAMES.HOTEL) return 'Выезд';
        return isMobile ? 'Обратная дата' : 'Обратно';
      },
      icon: <FlightOut width={24} height={24} />,
    },
  ],
  month: [
    {
      name: 'month',
      placeholder: () => 'Количество ночей',
      icon: <Calendar width={16} height={16} />,
    },
    {
      name: 'nightsCount',
      placeholder: () => 'Количество ночей',
      icon: <Nights width={16} height={16} />,
    },
  ],
};
